import img from '../pages/img/profile.png';


const About = () => {

  const skills = [
    'HTML',
    'CSS',
    'JavaScript',
    'Python',
    'Java',
    'Machine Learning',
    'Tailwindcss',
    'React.js',
    'React Native',
    'Node.js',
    'MongoDB'
  ]

    return (
      <main className='bg-gray-100 md:h-auto w-screen m-0'>
        <div className="max-w-lg mx-auto px-4 py-8">
          <img src={img} alt="Profile Picture" className="rounded-full w-48 h-48 mx-auto" />
          <p className="text-center font-fonts text-3xl font-bold mt-4 text-slate-600">
            About me
          </p>
          <p className="text-slate-500 text-base font-fonts mt-2">
            I'm Tonny Makondesa, a versatile full-stack developer who specializes in building intuitive and aesthetically pleasing websites. I am skilled at designing and implementing responsive layouts, animations, and interactive elements because of my expertise in HTML, CSS, and JavaScript. I have a strong background in machine learning techniques in addition to my expertise in web development, which enables me to integrate cutting-edge intelligence into web apps. I also have a lot of experience developing mobile apps, with a focus on creating interesting and useful programs utilizing tools like React Native. I do best in circumstances where there is teamwork, and I keep up with the most recent developments in the industry. Delivering excellent outcomes that satisfy the particular requirements and expectations of my clients is a promise I make.  
          </p>
          {skills.map((value)=>(
            <ul className='font-fonts inline-block text-slate-600'>
              <li className='mx-2 px-1 rounded-md bg-gray-400 text-sm'>{value}</li>
            </ul>
          ))}
        </div>  
      </main>      
     );
}
 
export default About;